import React, { useEffect } from 'react';
import { useInventoryPlanning } from '../contexts/InventoryPlanningContext';

type Props = {
  open: boolean;
  articleId: string | null;
  onClose: () => void;
};

const SelectSupplierLocationModal: React.FC<Props> = ({ open, articleId, onClose }) => {
  const { data, addSupplierSelection, addLocationSelection } = useInventoryPlanning();

  useEffect(() => {
    if (!open) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open, onClose]);

  if (!open || !articleId) return null;

  const articleSuppliers = (data?.article_suppliers || []).filter(
    (as: any) => String(as.article_supplier_article_ref) === String(articleId)
  );

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="bg-white rounded shadow-lg w-full max-w-lg">
        <div className="p-4 border-b font-medium">Sélectionner fournisseur / lieu</div>
        <div className="p-4 max-h-[60vh] overflow-auto">
          <div className="mb-3 text-sm text-gray-600">Article {articleId}</div>
          <div className="grid grid-cols-1 gap-3">
            {articleSuppliers.length === 0 && (
              <div className="text-gray-500">Aucun fournisseur lié à cet article.</div>
            )}
            {articleSuppliers.map((as: any) => {
              const sup = (data?.suppliers || []).find((s: any) => s.supplier_id === as.article_supplier_supplier_id);
              const supplierName = as.article_supplier_supplier_name || sup?.supplier_name || `Fournisseur ${as.article_supplier_supplier_id}`;
              const loc = sup?.supplier_location_group || 'N/A';
              return (
                <div key={as.article_supplier_id} className="border rounded p-3 flex items-center justify-between">
                  <div>
                    <div className="font-medium text-gray-900">{supplierName}</div>
                    <div className="text-xs text-gray-500">Lieu: {loc}</div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      className="px-2 py-1 text-xs bg-blue-600 text-white rounded"
                      onClick={() => {
                        addSupplierSelection(as.article_supplier_supplier_id, supplierName);
                        onClose();
                      }}
                    >
                      Ajouter fournisseur
                    </button>
                    <button
                      className="px-2 py-1 text-xs bg-indigo-600 text-white rounded"
                      onClick={() => {
                        addLocationSelection(String(loc));
                        onClose();
                      }}
                    >
                      Ajouter lieu
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="p-3 border-t flex justify-end">
          <button className="px-3 py-2 text-sm" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
};

export default SelectSupplierLocationModal;


